import dayjs from 'dayjs';

export const defaultDate = '2014-11-13T12:30:00';
export const startTime = dayjs(defaultDate).set('millisecond', 0);
